import React from 'react'
import { Card, Link, Typography } from '../base-ui'
import { css, useTheme } from '@emotion/react'

function ImageCard({ cardImage, cardColor = 'transparent', title, aspectRatio = '6 / 4', href }) {
    const theme = useTheme()
    const inner = <div css={css`
    position: relative;
    background: url('${cardImage}'), ${cardColor};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: ${theme.borderRadius.default};
    box-shadow: ${theme.boxShadow.default};
    aspect-ratio: ${aspectRatio};
    padding-bottom: 1rem;
    .card {
        width: 90%;
        margin: 0 auto;
        position: absolute;
        right: 5%;
        bottom: 1rem;
    }
`}>
        <Card spacing='sm'>
            <Typography type="h3" fontSize="1rem" lineClamp={3} fontWeight="Bold" hoverColor={href && 'primary'}>{title}</Typography>
        </Card>
    </div>
    if (href)
        return (
            <Link href={href}>
               {inner}
            </Link>
        )

    return inner
}

export default ImageCard